import { styled, keyframes } from "@mui/material/styles";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { COLOR_PRIMARY_MAIN, COLOR_WHITE } from "shared/theme/colors";

export const StyledCountIndicator = styled(FlexCenter)`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: ${COLOR_PRIMARY_MAIN};
  color: ${COLOR_WHITE};
`;

const blinkAnimation = keyframes`
  0%, 100% {
      opacity: 1;
  }
  50% {
      opacity: 0.5;
  }
`;

export const StyledLoadingCountIndicator = styled(FlexCenter)`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: ${COLOR_PRIMARY_MAIN};
  color: ${COLOR_WHITE};
  animation: ${blinkAnimation} 2s infinite;
`;
